<template>
  <BasePanel headline="lang_CONTRACTS_CAPTION_CONDITIONS" :alvqa="alvqa" :helpContext="getHelpContext">
    <template v-slot:panelContent>
      <v-container fluid class="pl-0">
        <v-row>
          <v-col>
            <v-data-table
              :headers="sheetsHeaders"
              :items="item"
              :expanded.sync="expandedItems"
              show-expand
              @click:row="expandItemByClick($event)"
              :header-props="{ sortIcon: '' }"
              :items-per-page="itemsPerPage"
              hide-default-footer
              sort-by="sheetNumber"
              :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
              class="noMinWidth"
            >
              <template
                v-for="(header, i) in sheetsHeaders"
                v-slot:[`header.${header.value}`]
              >
                <span :alvqa="header.alvqa" :key="i + '_header'">{{
                  header.text
                }}</span>
                <div v-if="header.value == 'actions'" :key="i">
                  <BaseIcon
                    :alvqa="alvqa + '-add-condition'"
                    icon="add"
                    tooltipText="lang_GENERAL_BUTTON_ADD_ROW"
                    @click.stop="openDialogCondition()"
                  />
                </div>
              </template>

              <template v-slot:[`item.data-table-expand`]="{ isExpanded }">
                <v-icon
                  v-if="isExpanded"
                  small
                  class="ma-0 pa-0"
                  color="buttonStandard"
                  >fa-arrow-alt-circle-down</v-icon
                >
                <v-icon v-else small class="ma-0 pa-0" color="buttonStandard"
                  >fa-arrow-alt-circle-right</v-icon
                >
              </template>
              <template v-slot:[`item.sourceId`]="{ item }">
                <BaseTooltip>
                  <template v-slot:content>
                    <div
                      :alvqa="alvqa + '-sheets-' + item.id + '-text-sourceId'"
                      class="ellipsis"
                    >
                      {{ getSourceName(item.sourceId) }}
                    </div>
                  </template>
                  <template v-slot:text>
                    {{ getSourceName(item.sourceId, true) }}
                  </template>
                </BaseTooltip>
              </template>
              <template v-slot:[`item.recipientId`]="{ item }">
                <BaseTooltip>
                  <template v-slot:content>
                    <div
                      class="ellipsis"
                      :alvqa="
                        alvqa + '-sheets-' + item.id + '-text-recipientId'
                      "
                    >
                      {{ item.recipientId ? $alvPlugin.showNameOfAzEntry(item.recipientId) : $t('lang_GENERIC_CAPTION_ANY') }}
                      <BaseIcon
                        :alvqa="alvqa + '-icon-recipient-id-copy-to-clipboard'"
                        :small="true"
                        icon="content_copy"
                        color="buttonStandard"
                        v-if="item.recipientId"
                        @click.stop="copyToClipboard(item.recipientId.alvId)"
                      />
                    </div>
                  </template>
                  <template v-slot:text>
                    {{ item.recipientId ? `${item.recipientId.gemaName} (${item.recipientId.alvId})` : $t('lang_GENERIC_CAPTION_ANY') }}
                  </template>
                </BaseTooltip>
              </template>
              <!-- SVAV columns - only rendered when headers include them (AUV contracts) -->
              <template v-slot:[`item.svavPublisherQuota`]="{ item }">
                <BaseTooltip>
                  <template v-slot:content>
                    <div
                      :alvqa="alvqa + '-sheets-' + item.id + '-text-svav-publisher-quota'"
                      class="ellipsis"
                    >
                      {{ item.svavPublisherQuota ? $alvPlugin.getNumberLocalization(item.svavPublisherQuota, 'number') + '%' : '' }}
                    </div>
                  </template>
                  <template v-slot:text>{{ item.svavPublisherQuota ? item.svavPublisherQuota + '%' : '' }}</template>
                </BaseTooltip>
              </template>
              <template v-slot:[`item.svavShareType`]="{ item }">
                <BaseTooltip>
                  <template v-slot:content>
                    <div
                      :alvqa="alvqa + '-sheets-' + item.id + '-text-svav-share-type'"
                      class="ellipsis"
                    >
                      {{ getSvavShareTypeName(item) }}
                    </div>
                  </template>
                  <template v-slot:text>{{ getSvavShareTypeName(item) }}</template>
                </BaseTooltip>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex">
                  <BaseIcon
                    :alvqa="alvqa + '-list-row-icon-inline-edit'"
                    icon="edit"
                    tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"
                    @click.stop="openDialogCondition(item)"
                  />
                  <BaseIcon
                    @click="deleteConditionRow(item)"
                    icon="delete"
                    color="iconDelete"
                    tooltipText="lang_GENERIC_CAPTION_DELETE"
                    :alvqa="alvqa + 'condition-row-' + item.id + '-icon-delete'"
                  />
                </div>
              </template>

              <template v-slot:expanded-item="{ item }">
                <td
                  colspan="1"
                  style="background-color: var(--v-expandPanelBackground-base)"
                ></td>
                <td
                  class="pl-0"
                  :colspan="sheetsHeaders.length - 1"
                  style="background-color: var(--v-expandPanelBackground-base)"
                >
                  <v-container fluid class="pl-0 pr-0">
                    <v-row>
                      <v-col class="pr-0">
                        <v-data-table
                          :headers="splitsHeaders"
                          hide-default-footer
                          :items="item.splits"
                          item-key="index"
                          :header-props="{ sortIcon: '' }"
                          :no-data-text="
                            $t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
                          "
                          :items-per-page="itemsPerPage"
                          class="noMinWidth"
                        >
                          <template
                            v-for="(header, i) in splitsHeaders"
                            v-slot:[`header.${header.value}`]
                          >
                            <span
                              :alvqa="header.alvqa + '-' + item.sheetNumber"
                              :key="i"
                              >{{ header.text }}</span
                            >
                            <div
                              v-if="header.value == 'actions'"
                              :key="i + '_split_header'"
                            >
                              <BaseIcon
                                :alvqa="alvqa + '-add-split'"
                                icon="add"
                                tooltipText="lang_GENERAL_BUTTON_ADD_ROW"
                                @click.stop="openDialogSplits(item.id)"
                              />
                            </div>
                          </template>

                          <template v-slot:[`item.rightsType`]="{ item }">
                            <BaseTooltip>
                              <template v-slot:content>
                                <div
                                  class="ellipsis"
                                  :alvqa="
                                    alvqa +
                                    '-conditions-list-row-' +
                                    item.id +
                                    '-text-rights-type'
                                  "
                                >
                                  {{ getRightTypeName(item.rightsType) }}
                                </div></template
                              >
                              <template v-slot:text>{{
                                getRightTypeName(item.rightsType)
                              }}</template>
                            </BaseTooltip>
                          </template>
                          <template v-slot:[`item.category`]="{ item }">
                            <BaseTooltip>
                              <template v-slot:content>
                                <div
                                  class="ellipsis"
                                  :alvqa="
                                    alvqa +
                                    '-conditions-list-row-' +
                                    item.id +
                                    '-text-category'
                                  "
                                >
                                  {{ getCategoryName(item.category) }}
                                </div>
                              </template>
                              <template v-slot:text>{{
                                getCategoryName(item.category)
                              }}</template>
                            </BaseTooltip>
                          </template>
                          <template v-slot:[`item.subCategory`]="{ item }">
                            <BaseTooltip>
                              <template v-slot:content>
                                <div
                                  class="ellipsis"
                                  :alvqa="
                                    alvqa +
                                    '-conditions-list-row-' +
                                    item.id +
                                    '-text-sub-category'
                                  "
                                >
                                  {{ item.subCategory }}
                                </div>
                              </template>
                              <template v-slot:text>{{
                                item.subCategory
                              }}</template>
                            </BaseTooltip>
                          </template>
                          <template v-slot:[`item.base`]="{ item }">
                            <div
                              :alvqa="
                                alvqa +
                                '-conditions-list-row-' +
                                item.id +
                                '-text-abase'
                              "
                            >
                              {{ $alvPlugin.getNumberLocalization(item.base, 'number') }}
                            </div>
                          </template>
                          <template v-slot:[`item.split`]="{ item }">
                            <div
                              :alvqa="
                                alvqa +
                                '-conditions-list-row-' +
                                item.id +
                                '-text-split'
                              "
                            >
                              {{ $alvPlugin.getNumberLocalization(item.split, 'number') }}
                            </div>
                          </template>
                          <template v-slot:[`item.weighting`]="{ item }">
                            <div
                              :alvqa="
                                alvqa +
                                '-conditions-list-row-' +
                                item.id +
                                '-text-weighting'
                              "
                            >
                              {{ geWeightingName(item.weighting) }}
                            </div>
                          </template>
                          <template v-slot:[`item.applyTo`]="{ item }">
                            <BaseTooltip>
                              <template v-slot:content>
                            <div
                              :alvqa="
                                alvqa +
                                '-conditions-list-row-' +
                                item.id +
                                '-text-apply-to'
                              "
                            >
                            {{ getApplyToName(item.applyTo) }}
                            </div>
                            </template>
                            <!-- this is the mouseover text -->
                            <template v-slot:text v-if="item.applyTo !='incomingMoney'">
                                {{ item.recipientId ? `${item.recipientId.gemaName} (${item.recipientId.alvId})` : '' }}
                            </template>
                            <template v-slot:text v-else>
                                {{ getApplyToName(item.applyTo) }}
                            </template>
                          </BaseTooltip>
                          </template>
                          <template v-slot:[`item.region`]="{ item }">
                            <div :alvqa="alvqa + '-list-row-' + item.id + '-text-region'">
                              {{ $alvPlugin.createRegionsToString(item.region) }}
                            </div>
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <div class="d-flex">
                              <BaseIcon
                                :alvqa="alvqa + '-list-row-icon-inline-edit'"
                                icon="edit"
                                tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"
                                @click.stop="openDialogSplits(null, item)"
                              />
                              <BaseIcon
                                @click="deleteSplitRow(item)"
                                icon="delete"
                                color="iconDelete"
                                tooltipText="lang_GENERIC_CAPTION_DELETE"
                                :alvqa="
                                  alvqa +
                                  'split-row-' +
                                  item.id +
                                  '-icon-delete'
                                "
                              />
                            </div>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </td>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </BasePanel>
</template>

<script>
import BasePanel from "@/components/_base/BasePanel";
import BaseTooltip from "@/components/_base/BaseTooltip";
import BaseIcon from "@/components/_buttons/BaseIcon";
import {
  DropdownRightsType,
  DropdownCategory,
  DropdownWeighting,
  DropdownContractsPublishingSplitsApplyTo,
  DropdownWeightingSource,
} from "@/assets/dropdowns/alvDropdowns.js";

export default {
  name: "PublishingProjectsReadOnly",
  components: {
    BasePanel,
    BaseTooltip,
    BaseIcon,
  },
  props: {
    itemId: {
      type: Number,
    },
  },
  data() {
    return {
      expandedItems: [],
      alvqa:
        "publishing-contracts-conditions-list-row-" +
        this.itemId +
        "-read-only",
      context: "PublishingContract"
    };
  },
  watch: {
    item() {
      this.expandedItems = [];
    },
  },
  computed: {
    getHelpContext() {
      return 'PublishingContractsEditPanelConditions'
    },
    item() {
      this.$store.commit("setIsLoading", true);
      this.$store.dispatch("fetchPublishingContractConditions");
      return this.$store.getters.getPublishingContractConditions;
    },
    sheetsHeaders() {
      let headers = [
        {
          text: "",
          value: "data-table-expand",
          align: "center",
          width: "48px",
        },
        {
          text: this.$t("lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_SOURCE"),
          value: "sourceId",
          align: "left",
          sortable: false,
          class: "text-no-wrap",
          width: "20%",
          alvqa: this.alvqa + "-sheets-header-source-id",
        },
        {
          text: this.$t("lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_RECIPIENT"),
          value: "recipientId",
          align: "left",
          sortable: false,
          width: this.isAuvContract ? "40%" : "70%",
          alvqa: this.alvqa + "-sheets-header-recipient-id",
        },
      ];
      
      // SVAV columns - only for AUV contract type
      if (this.isAuvContract) {
        headers.push({
          text: this.$t("lang_CONTRACTS_PUBLISHING_CAPTION_SVAV_PUBLISHER_QUOTA"),
          value: "svavPublisherQuota",
          align: "left",
          sortable: false,
          width: "15%",
          class: "ellipsis",
          alvqa: this.alvqa + "-sheets-header-svav-publisher-quota",
        });
        headers.push({
          text: this.$t("lang_PUBLISHING_CAPTION_SHARE_TYPE"),
          value: "svavShareType",
          align: "left",
          sortable: false,
          width: "15%",
          alvqa: this.alvqa + "-sheets-header-svav-share-type",
        });
      }
      
      headers.push({
        text: "",
        value: "actions",
        align: "right",
        sortable: false,
        width: "100px",
        alvqa: this.alvqa + "-actions",
      });
      
      return headers;
    },
    splitsHeaders() {
      return [
        {
          text: this.$t("lang_GENERIC_CAPTION_RIGHTS_TYPE"),
          value: "rightsType",
          align: "left",
          sortable: false,
          class: "text-no-wrap",
          alvqa: this.alvqa + "-conditions-splits-header-rights-type",
        },
        {
          text: this.$t("lang_GENERIC_CAPTION_CATEGORY"),
          value: "category",
          align: "left",
          sortable: false,
          alvqa: this.alvqa + "-conditions-splits-header-category",
        },
        {
          text: this.$t("lang_PUBLISHING_INCOME_CAPTION_SUB_CATEGORY"),
          value: "subCategory",
          align: "left",
          sortable: false,
          alvqa: this.alvqa + "-conditions-splits-header-sub-category",
        },
        {
          text: this.$t("lang_GENERIC_CAPTION_REGION"),
          value: "region",
          align: "left",
          sortable: false,
          alvqa: this.alvqa + "-conditions-splits-header-region",
        },
        {
          text: this.$t("lang_CONTRACTS_PUBLISHING_EDIT_SHARES_PANEL_CAPTION_BASE"),
          value: "base",
          sortable: false,
          width: "70px",
          align: "left",
          class: "text-no-wrap",
          alvqa: this.alvqa + "-conditions-splits-header-base",
        },
        {
          text: `${this.$t("lang_GENERIC_CAPTION_SPLIT")}%`,
          value: "split",
          align: "left",
          width: "70px",
          sortable: false,
          class: "text-no-wrap",
          alvqa: this.alvqa + "-conditions-splits-header-split",
        },
        {
          text: this.$t("lang_PUBLISHING_CAPTION_WEIGHTING"),
          value: "weighting",
          align: "left",
          sortable: false,
          class: "text-no-wrap",
          alvqa: this.alvqa + "-conditions-splits-header-weighting",
        },
        {
          text: this.$t("lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_SPLITS_APPLY_TO"),
          value: "applyTo",
          sortable: false,
          align: "left",
          class: "text-no-wrap",
          alvqa: this.alvqa + "-conditions-splits-header-apply-to",
        },
        {
          text: "",
          value: "actions",
          align: "right",
          sortable: false,
          width: "100px",
          alvqa: this.alvqa + "-actions",
        },
      ];
    },
    itemsPerPage() {
      return this.$store.getters.getItemsPerPage;
    },
    applyToDropdownItems() {
      let alvqa = this.alvqa + "-dropdown-apply-to";
      let applyToArr;
      let applyTo = DropdownContractsPublishingSplitsApplyTo;

      if (applyTo !== undefined) {
        applyToArr = JSON.parse(JSON.stringify(applyTo));
        applyToArr.forEach((element) => {
          element["alvqa"] = alvqa + element.value;
        });
      }
      return applyToArr;
    },
    isAuvContract() {
      return this.$store.getters.getPublishingContractsDetailsContractType === 'AUV';
    },
  },
  methods: {
    copyToClipboard(item) {
      navigator.clipboard.writeText(item);
    },
    getApplyToName(value) {
      var current = this.applyToDropdownItems.find((el) => el.value == value);
      return current ? this.$t(current.text) : "";
    },
    geWeightingName(value) {
      var current = DropdownWeighting.find((el) => el.value == value);
      return current ? this.$t(current.text) : "";
    },
    getCategoryName(value) {
      // var current = DropdownCategory.find((el) => el.value == value);
      return value;
    },
    getSourceName(value, detailed=false) {
      if (!value || (Array.isArray(value) && value.length === 0)) {
        return this.$t('lang_GENERIC_CAPTION_ANY')
      }
      if (!Array.isArray(value)) { return ; }

      // filter out selected sources and map it into array of source names
      let foundSourceNames = this.$store.getters.getAzForMappingsImport.filter(
        (el) => value.includes(el.value)
      ).map((el) => {
        if (this.$alvPlugin.isLangConst(el.text)) {
          return this.$t(el.text)
        }
        return el.text
      });

      if (detailed === true || foundSourceNames.length === 1) {
        return foundSourceNames.join(', ')
      }

      return this.$t('lang_GENERAL_CAPTION_MULTIPLE');
    },
    getRightTypeName(value) {
      var current = DropdownRightsType.find((el) => el.value == value);
      return current ? this.$t(current.text) : "";
    },
    getSvavShareTypeName(item) {
      // First check in standard share types (role, intl, own)
      let foundItem = DropdownWeightingSource.find((el) => el.value == item.svavShareType);
      if (foundItem) {
        return this.$t(foundItem.text);
      }
      // Otherwise it's a society code - get the society name
      if (item.svavShareType) {
        return this.$alvPlugin.getSocietyPanelHeadline(parseInt(item.svavShareType));
      }
      return "";
    },
    deleteSplitRow(item) {
      this.$store.commit("setSelectedPublishingContractConditionsSplits", item);
      this.$store.commit(
        "setDeletionDialogContext",
        "SelectedPublishingContractConditionsSplits"
      );
      this.$store.commit("setShowDeletionDialog", true);
    },
    deleteConditionRow(item) {
      this.$store.commit("setSelectedPublishingContractConditions", [item.id]);
      this.$store.commit(
        "setDeletionDialogContext",
        "SelectedPublishingContractConditions"
      );
      this.$store.commit("setShowDeletionDialog", true);
    },
    openDialogCondition(item = null) {
      let defaultValues = JSON.parse(
          JSON.stringify(
            this.$store.getters.getDefaultPublishingContractConditions
          )
      );
      if (!item) {
        this.$store.commit("setEditingDialogHeadline", this.$t("lang_ADD_ROW"));

        this.$store.commit(
          "setPublishingContractConditionsEditingDialogDetails",
          defaultValues
        );
      } else {
        this.$store.commit(
          "setEditingDialogHeadline",
          this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")
        );
        this.$store.commit("setSelectedPublishingContractConditions", item.id);
        // Merge with defaults in case there are attributes missing from backend
        let detailsDeepCopy = {...defaultValues ,...JSON.parse(JSON.stringify(item))};

        if (detailsDeepCopy.recipientId) {
          this.$store.commit(
            "setPublishingContractConditionsRecipientIdOptions",
            [detailsDeepCopy.recipientId]
          );
        }
        this.$store.commit(
          "setPublishingContractConditionsEditingDialogDetails",
          detailsDeepCopy
        );
      }
      this.$store.commit(
        "setShowPublishingContractConditionsEditingDialog",
        true
      );
    },
    openDialogSplits(conditionId, item = null) {
      if (!conditionId) {
        conditionId = this.$store.getters.getPublishingContractConditions.find(
          (el) => el.splits.some((elem) => elem.id == item.id)
        ).id;
      }
      this.$store.commit("setActiveConditionId", conditionId);
      if (!item) {
        this.$store.commit("setEditingDialogHeadline", this.$t("lang_ADD_ROW"));
        let defaultValues = JSON.parse(
          JSON.stringify(
            this.$store.getters.getDefaultPublishingContractConditionsSplits
          )
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsEditingDialogDetails",
          defaultValues
        );
        this.$store.commit(
          "setSelectedPublishingContractConditionsSplits",
          null
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsRightsType",
          defaultValues.rightsType
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsCategory",
          defaultValues.category
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsInclude",
          []
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsExclude",
          []
        );
      } else {
        this.$store.commit(
          "setEditingDialogHeadline",
          this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")
        );
        let detailsDeepCopy = JSON.parse(JSON.stringify(item));
        this.$store.commit(
          "setSelectedPublishingContractConditionsSplits",
          item.id
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsEditingDialogDetails",
          detailsDeepCopy
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsRightsType",
          detailsDeepCopy.rightsType
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsCategory",
          detailsDeepCopy.category
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsSubCategory",
          detailsDeepCopy.subCategory
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsSplit",
          this.$alvPlugin.getNumberLocalization(detailsDeepCopy.split, 'number')
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsWeighting",
          detailsDeepCopy.weighting
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsWeightingSource",
          detailsDeepCopy.weightingSource
        );

        const sharesToConsider = detailsDeepCopy.sharesToConsider;
        if (typeof sharesToConsider === 'object' && sharesToConsider !== null) {
            this.$store.commit('setPublishingContractConditionsSplitsSharesToConsiderOptions', [sharesToConsider]);
            this.$store.commit('setPublishingContractConditionsSplitsDetailsSharesToConsider', sharesToConsider);
        } else {
            this.$store.commit("setPublishingContractConditionsSplitsDetailsSharesToConsider", sharesToConsider);
        }

        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsApplyTo",
          detailsDeepCopy.applyTo
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsOrder",
          detailsDeepCopy.order
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsBase",
          this.$alvPlugin.getNumberLocalization(detailsDeepCopy.base, 'number')
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsRecipientIdOptions",
          [detailsDeepCopy.recipientId]
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsRecipientId",
          detailsDeepCopy.recipientId
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsInclude",
          detailsDeepCopy.region.include
        );
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsExclude",
          detailsDeepCopy.region.exclude
        );
      }
      this.$store.commit(
        "setShowPublishingContractConditionsSplitsEditingDialog",
        true
      );
    },
    // Expand behaviour when clicking on a row.
    async expandItemByClick(item) {
      if (this.expandedItems.includes(item)) {
        // close item.
        let indexOfItem = this.expandedItems.indexOf(item);
        this.expandedItems.splice(indexOfItem, 1);
      } else {
        // open item
        this.expandedItems.push(item);
      }
    },
    // Fetch A-Z object from ALVID for autocomplete restoration
    async fetchAzObjectForAutocomplete(alvId) {
      try {
        // Check store cache first
        const azPersonsCache = this.$store.getters.getAzPersonsCache;
        const cachedObject = azPersonsCache[alvId];
        if (cachedObject) {
          // Set the options first (autocomplete expects it in the list)
          this.$store.commit(
            "setPublishingContractConditionsSplitsSharesToConsiderOptions",
            [cachedObject]
          );
          
          // Set the cached A-Z object to the store for the autocomplete
          this.$store.commit(
            "setPublishingContractConditionsSplitsDetailsSharesToConsider",
            cachedObject
          );
          return;
        }
        
        // Fetch the A-Z person details directly by ALVID if not cached
        const response = await this.$api.getDetailsById('az/persons', alvId);
        
        if (response && !response.error) {
          // Transform the response to match autocomplete format
          const azObject = {
            alvId: response.alvId,
            name: response.name || response.gemaName,
            gemaName: response.gemaName,
            firstName: response.firstName,
            lastName: response.lastName,
            ipi: (response.metadata && response.metadata.ipi) || response.ipi || '',
            typeOfAz: response.typeOfAz || 'P'
          };
          
          // Cache the object for future use in store
          this.$store.commit("setAzPersonInCache", { alvId, azObject });
          
          // Set the options first (autocomplete expects it in the list)
          this.$store.commit(
            "setPublishingContractConditionsSplitsSharesToConsiderOptions",
            [azObject]
          );
          
          // Set the full A-Z object to the store for the autocomplete
          this.$store.commit(
            "setPublishingContractConditionsSplitsDetailsSharesToConsider",
            azObject
          );
        } else {
          console.warn(`A-Z object with ALVID ${alvId} not found, falling back to string value`);
          // Fallback to the string value if object not found
          this.$store.commit(
            "setPublishingContractConditionsSplitsDetailsSharesToConsider",
            alvId
          );
        }
      } catch (error) {
        console.error(`Error fetching A-Z object for ALVID ${alvId}:`, error);
        // Fallback to the string value on error
        this.$store.commit(
          "setPublishingContractConditionsSplitsDetailsSharesToConsider",
          alvId
        );
      }
    },
  },
  created() {
    this.$store.commit('setSocieties')
  }
};
</script>

<style>
.noMinWidth table {
  min-width: 0px !important;
  table-layout: fixed;
}
</style>